module.exports = __webpack_public_path__ + "static/media/GREY_Button@3x.966abc7b.png";